import { Card, IconName, SimpleList, Stack, Typography } from '@optimus-web/core';
import { HighlightIcon } from '@mews/b2b-ui';
import { SecurityOverviewBadgeEnum } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { SecurityDataTestId } from '../utils/SecurityDataTestId';
import { securityOverviewContent } from './contentMapping';

export const SecurityTips = ({ level }: { level?: SecurityOverviewBadgeEnum }) => {
    if (level === SecurityOverviewBadgeEnum.VeryHigh || typeof level === 'undefined') {
        return null;
    }

    const listContent = securityOverviewContent[level].tipsTextKey;

    return (
        <Card padding="200" data-test-id={SecurityDataTestId.SecurityLevelTips}>
            <Stack spacing="150">
                <HighlightIcon icon={IconName.BulbStars} size="medium" variant="info" />
                <Stack vertical>
                    <Typography textStyle="bodySmallStrong" as="p">
                        {lt('SecurityOverviewTipsTitle')}
                    </Typography>
                    <SimpleList spacing="300">
                        {lt(listContent, {
                            li: (text) => <li>{text}</li>,
                        })}
                    </SimpleList>
                </Stack>
            </Stack>
        </Card>
    );
};
